import { ProviderStatus } from '../../../services/types/treatment-types';

interface ProviderStatusBadgeProps {
  status?: ProviderStatus;
  className?: string;
}

export const ProviderStatusBadge = ({
  status,
  className,
}: ProviderStatusBadgeProps) => {
  if (!status) {
    return (
      <span
        className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium bg-gray-100 text-gray-600 ${className}`}
      >
        Pending
      </span>
    );
  }

  const statusConfig = {
    [ProviderStatus.NEEDS_APPROVAL]: {
      bg: 'bg-amber-100',
      text: 'text-amber-800',
      label: 'Unreviewed',
    },
    [ProviderStatus.APPROVED]: {
      bg: 'bg-emerald-100',
      text: 'text-emerald-800',
      label: 'Reviewed',
    },
    [ProviderStatus.REJECTED]: {
      bg: 'bg-red-100',
      text: 'text-red-800',
      label: 'Rejected',
    },
  };

  const config =
    statusConfig[status] || statusConfig[ProviderStatus.NEEDS_APPROVAL];

  return (
    <span
      className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ${config.bg} ${config.text} ${className}`}
    >
      {config.label}
    </span>
  );
};
